import apiFetch from '../../apiFetch'

export default function (serviceDossierId, token) {
  return apiFetch({ endPoint: `Dossier/Service/${serviceDossierId}/Approve`, method: 'PUT', token: token })
}
